// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__FEPIL","radio":"styles_radio__nBwpF","switch":"styles_switch__DvWl0"};